import { Box } from '@mui/material';
import { useRef } from 'react';
import { getCanvas, ReactLassoSelect } from 'react-lasso-select';
import { canvasToFile } from './imageExportUtils';
import { LassoPoint } from './types';

type LassoAction = Parameters<ReactLassoSelect['dispatchPathAction']>[0];

const IMAGE_STYLE = {
  width: '100%' as const,
  height: '100%' as const,
  objectFit: 'contain' as const,
};

type LassoToolProperties = {
  imageUrl: string;
  points: LassoPoint[];
  onPointsChange: (points: LassoPoint[]) => void;
  onExport: (file: File) => void;
  originalFileName: string;
  containerWidth: number;
  containerHeight: number;
};

export const LassoTool = ({
  imageUrl,
  points,
  onPointsChange,
  onExport,
  originalFileName,
  containerWidth,
  containerHeight,
}: LassoToolProperties) => {
  const lassoReference = useRef<ReactLassoSelect>(null);

  const handleComplete = (path: LassoPoint[]) => {
    onPointsChange(path);
    if (path.length >= 3) {
      getCanvas(imageUrl, path, (error, canvas) => {
        if (error || !canvas) return;
        canvasToFile(canvas, originalFileName).then(onExport);
      });
    }
  };

  const handleDoubleClick = () => {
    const lasso = lassoReference.current;
    if (!lasso?.path?.points?.length || lasso.path.points.length < 3 || lasso.path.closed) return;

    lasso.dispatchPathAction({ type: 'ADD', payload: { ...lasso.path.points[0] } } as LassoAction);
  };

  return (
    <Box
      sx={{ position: 'relative', width: containerWidth, height: containerHeight }}
      onDoubleClick={handleDoubleClick}
    >
      <ReactLassoSelect
        ref={lassoReference}
        src={imageUrl}
        value={points}
        onChange={onPointsChange}
        onComplete={handleComplete}
        style={{ width: containerWidth, height: containerHeight }}
        imageStyle={IMAGE_STYLE}
      />
    </Box>
  );
};
